<template>
	<div>
		<van-overlay
		  :show="showShare"
		  @click="showShare = false"
		  z-index="100000"
		  ref="overs"
		>
		
		</van-overlay>
    </div>
</template>
<script>
	export default{
		data(){
			return {
				showShare:false,
				theimgs:this.$mAssetsPath.shareimg,
			}
		},
		mounted() {
			 var dom=document.createElement('div');
			 dom.className='book';
			 dom.style=`z-index: 1000;`;
			 dom.innerHTML=`<div style="text-align:right;"><img ref="shareimg"id="shareimg" ></div>
			 	<div class="textCenter" style="color:white;font-size:16px;">邀请分享: 点击右上角发送给朋友</div>`;
			 this.$refs.overs.appendChild(dom);
			 var shareimg=document.getElementById('shareimg');
			 shareimg.src=this.theimgs;
		},
		created() {
		},
		methods: {
		    show() {
		      this.showShare=true;
			  
		    }
  		}
	}
</script>